import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { RecaptchaPlacement } from 'interfaces/recaptcha'
import { createOwnPropsSelector } from 'selectors/globalSelectors'

const recaptchaState = (state: State) => state.app.recaptcha

export const recaptchaIsFailedToLoadSelector = createSelector(
  recaptchaState,
  (state) => state.status === 'failed'
)

export const recaptchaWidgetByPlacementSelector = createSelector(
  recaptchaState,
  createOwnPropsSelector<{ placement: RecaptchaPlacement }>(),
  (state, ownProps) => state.widgets[ownProps.placement]
)
